import React from 'react';
import { styled } from '@teko/ui';
import messengerFull from '../../assets/images/live-chat-full.es.js';
import messenger from '../../assets/images/live-chat.es.js';
import { getTrackingData } from '@teko/tracking';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const Wrapper = styled.a`
  z-index: 1030;
  position: fixed;
  right: 2.5rem;
  bottom: 5.6rem;
  cursor: pointer;
  @media (min-width: 1440px) {
    .fb-chat-full {
      display: block;
    }
    .fb-chat {
      display: none;
    }
  }
  @media (max-width: 1440px) {
    .fb-chat-full {
      display: none;
    }
    .fb-chat {
      display: block;
    }
  }
  @media print {
    display: none;
  }
`;
const Messenger = ({
  url
}) => {
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadValues({
    href: url,
    target: "_blank",
    rel: "noreferrer"
  }, getTrackingData({
    isTrackContent: true,
    regionName: "quickAction",
    contentName: "fbMessengerIcon"
  })), /* @__PURE__ */ React.createElement("img", {
    className: "fb-chat-full",
    src: messengerFull,
    alt: "fb-chat"
  }), /* @__PURE__ */ React.createElement("img", {
    className: "fb-chat",
    src: messenger,
    alt: "fb-chat"
  }));
};

export { Messenger };
